module.exports = __webpack_public_path__ + "media/images/static_banner_background-e3c5ec6260db6401803b6f9693690cfc.png";